(function() {
    // Gestion du toggle des communications global
    var triggers = document.querySelectorAll('[data-communication="all"]');
    if (triggers.length === 0) return;

    Array.from(triggers).forEach(function(trigger) {
        trigger.addEventListener('click', function() {
            var targets = document.querySelectorAll('[data-communication="all_target"]');
            if (targets.length > 0) {
                Array.from(targets).forEach(function(target) {
                    if (trigger.checked) {
                        target.checked = true;
                        target.classList.add('is-readonly');
                    } else {
                        target.classList.remove('is-readonly');
                    }
                });
            }
        })
    });
})();
